/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SanGameAssets} from "../SanGameAssets";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import { ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";

export class SanIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000,
            backgroundAlpha:0.6,
            bulletColor:0xffffff
        },
        stampColor:0xFFFFFF,
    };


    stampConfig:StampConfig = {
        xWays:true,
        volatility:Volatility.EXTREME
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    public init():Promise<GameIntroViewConfig> {

        const imgLoader:ImgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(SanGameAssets.INTRO_BACKGROUND, SanGameAssets.INTRO_BACKGROUND);
        imgLoader.add(SanGameAssets.INTRO_BORDER_TILE, SanGameAssets.INTRO_BORDER_TILE);
        imgLoader.add(SanGameAssets.FEATURE_1, SanGameAssets.FEATURE_1);
        imgLoader.add(SanGameAssets.FEATURE_2, SanGameAssets.FEATURE_2);
        imgLoader.add(SanGameAssets.FEATURE_3, SanGameAssets.FEATURE_3);
        imgLoader.add(SanGameAssets.INTRO_LOGO, SanGameAssets.INTRO_LOGO);

        return new Promise<GameIntroViewConfig>((resolve, reject) => {
            imgLoader.load().then(value => {
                this.initGraphics();
                resolve(this);
                return value;
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    onResize() {
        (<PIXI.Sprite>this.logo.children[0]).scale = NolimitApplication.isLandscape ? new PIXI.Point(0.75,0.75) : new PIXI.Point(0.75,0.75);
        (<PIXI.Sprite>this.logo.children[0]).anchor =  NolimitApplication.isLandscape ? new PIXI.Point(0.5,0.2) : new PIXI.Point(0.5,0.75);
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        bgBlack.anchor.set(0.5, 0.5);
        bgBlack.tint = 0x000000;
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(SanGameAssets.INTRO_BACKGROUND));
        bgSprite.anchor.set(0.5, 0.5);

        this.background.addChild(bgBlack);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture(SanGameAssets.INTRO_BORDER_TILE), 1680, 77);
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture(SanGameAssets.INTRO_BORDER_TILE), 1680, 77);
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logo = new PIXI.Sprite(ImgLoader.getImgTexture(SanGameAssets.INTRO_LOGO));
        logo.anchor.set(0.5, 0.5);
        this.logo.addChild(logo);

        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture(SanGameAssets.FEATURE_1)),
            new SlideShowPage(ImgLoader.getImgTexture(SanGameAssets.FEATURE_2)),
            new SlideShowPage(ImgLoader.getImgTexture(SanGameAssets.FEATURE_3))
        ];

        this.pages.forEach(p => (<PIXI.Sprite>p.children[0]).anchor.x = 0.5)

    }
}